module.exports = __webpack_public_path__ + "static/GoodMono-Regular-89ef56479848dd74bad91c1be7e17a89.otf";